"use strict";

require("core-js/modules/esnext.global-this.js");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("react-dom/server"),
    r = require("styled-components"),
    n = require("react-dom"),
    o = require("prop-types");

function a(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var u = a(e),
    l = a(o),
    c = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function i(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var s = i(function (e) {
  !function (t) {
    var r = function r(e, t, n) {
      if (!c(t) || s(t) || f(t) || d(t) || l(t)) return t;
      var o,
          a = 0,
          u = 0;
      if (i(t)) for (o = [], u = t.length; a < u; a++) {
        o.push(r(e, t[a], n));
      } else for (var p in o = {}, t) {
        Object.prototype.hasOwnProperty.call(t, p) && (o[e(p, n)] = r(e, t[p], n));
      }
      return o;
    },
        n = function n(e) {
      return p(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
        return t ? t.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + e.substr(1);
    },
        o = function o(e) {
      var t = n(e);
      return t.substr(0, 1).toUpperCase() + t.substr(1);
    },
        a = function a(e, t) {
      return function (e, t) {
        var r = (t = t || {}).separator || "_",
            n = t.split || /(?=[A-Z])/;
        return e.split(n).join(r);
      }(e, t).toLowerCase();
    },
        u = Object.prototype.toString,
        l = function l(e) {
      return "function" == typeof e;
    },
        c = function c(e) {
      return e === Object(e);
    },
        i = function i(e) {
      return "[object Array]" == u.call(e);
    },
        s = function s(e) {
      return "[object Date]" == u.call(e);
    },
        f = function f(e) {
      return "[object RegExp]" == u.call(e);
    },
        d = function d(e) {
      return "[object Boolean]" == u.call(e);
    },
        p = function p(e) {
      return (e -= 0) == e;
    },
        y = function y(e, t) {
      var r = t && "process" in t ? t.process : t;
      return "function" != typeof r ? e : function (t, n) {
        return r(t, e, n);
      };
    },
        h = {
      camelize: n,
      decamelize: a,
      pascalize: o,
      depascalize: a,
      camelizeKeys: function camelizeKeys(e, t) {
        return r(y(n, t), e);
      },
      decamelizeKeys: function decamelizeKeys(e, t) {
        return r(y(a, t), e, t);
      },
      pascalizeKeys: function pascalizeKeys(e, t) {
        return r(y(o, t), e);
      },
      depascalizeKeys: function depascalizeKeys() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };

    e.exports ? e.exports = h : t.humps = h;
  }(c);
}).decamelize,
    f = i(function (e) {
  function t() {
    return e.exports = t = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }, t.apply(this, arguments);
  }

  e.exports = t;
});

var d = function d(e) {
  if (Array.isArray(e)) return e;
};

var p = function p(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var r = [],
        n = !0,
        o = !1,
        a = void 0;

    try {
      for (var u, l = e[Symbol.iterator](); !(n = (u = l.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, a = e;
    } finally {
      try {
        n || null == l.return || l.return();
      } finally {
        if (o) throw a;
      }
    }

    return r;
  }
};

var y = function y(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }

  return n;
};

var h = function h(e, t) {
  if (e) {
    if ("string" == typeof e) return y(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y(e, t) : void 0;
  }
};

var v = function v() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};

var m = function m(e, t) {
  return d(e) || p(e, t) || h(e, t) || v();
};

var g = function g(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
  }

  return o;
};

var b = function b(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = g(e, t);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (n = 0; n < a.length; n++) {
      r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
};

var S = e.createContext(null);

function w(e) {
  var t = e.root,
      r = e.children;
  return n.createPortal(r, t);
}

function O(t) {
  var r = e.forwardRef(function (r, n) {
    var o,
        a,
        l = r.mode,
        c = r.delegatesFocus,
        i = r.styleSheets,
        s = r.ssr,
        d = r.children,
        p = b(r, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]),
        y = (o = n, a = e.useRef(o && o.current), e.useEffect(function () {
      o && (o.current = a.current);
    }, [o]), a),
        h = e.useState(null),
        v = m(h, 2),
        g = v[0],
        O = v[1],
        j = "node_".concat(l).concat(c);
    return e.useLayoutEffect(function () {
      if (y.current) try {
        if ("function" == typeof n && n(y.current), s) {
          var e = y.current.shadowRoot;
          return void O(e);
        }

        var t = y.current.attachShadow({
          mode: l,
          delegatesFocus: c
        });
        i.length > 0 && (t.adoptedStyleSheets = i), O(t);
      } catch (e) {
        !function (e) {
          var t = e.error,
              r = e.styleSheets,
              n = e.root;

          switch (t.name) {
            case "NotSupportedError":
              r.length > 0 && (n.adoptedStyleSheets = r);
              break;

            default:
              throw t;
          }
        }({
          error: e,
          styleSheets: i,
          root: g
        });
      }
    }, [n, y, i]), u.default.createElement(u.default.Fragment, null, u.default.createElement(t.tag, f({
      key: j,
      ref: y
    }, p), (g || s) && u.default.createElement(S.Provider, {
      value: g
    }, s ? u.default.createElement("template", {
      shadowroot: "open"
    }, t.render({
      root: g,
      ssr: s,
      children: d
    })) : u.default.createElement(w, {
      root: g
    }, t.render({
      root: g,
      ssr: s,
      children: d
    })))));
  });
  return r.propTypes = {
    mode: l.default.oneOf(["open", "closed"]),
    delegatesFocus: l.default.bool,
    styleSheets: l.default.arrayOf(l.default.instanceOf(globalThis.CSSStyleSheet)),
    ssr: l.default.bool,
    children: l.default.node
  }, r.defaultProps = {
    mode: "open",
    delegatesFocus: !1,
    styleSheets: [],
    ssr: !1,
    children: null
  }, r;
}

w.propTypes = {
  root: l.default.object.isRequired,
  children: l.default.node
}, w.defaultProps = {
  children: null
};
var j = new Map();

function E() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core",
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (e) {
    return e.children;
  };
  return new Proxy(e, {
    get: function get(e, n) {
      var o = s(n, {
        separator: "-"
      }),
          a = "".concat(t, "-").concat(o);
      return j.has(a) || j.set(a, O({
        tag: o,
        render: r
      })), j.get(a);
    }
  });
}

function x(e) {
  var n = new r.ServerStyleSheet();
  return t.renderToString(u.default.createElement(r.StyleSheetManager, {
    sheet: n.instance
  }, u.default.createElement(u.default.Fragment, null, e))), n.getStyleElement();
}

E();
var z = E({}, "styled-components", function (e) {
  var t = e.root,
      n = e.ssr,
      o = e.children;
  return n ? u.default.createElement(u.default.Fragment, null, x(o), o) : u.default.createElement(r.StyleSheetManager, {
    target: t
  }, u.default.createElement(u.default.Fragment, null, o));
});
exports.default = z, exports.getStyleSheets = x;